export default __webpack_public_path__ + "static/media/good5-detail-1.bf5fd189.png";